import Cropper from "react-easy-crop";

import {
  anchorClassNames,
  legacyClassNames,
} from "@/react/helpers/cssAnchorHelpers";

import { CropSlider } from "./CropSlider";
import { ImageError } from "./ImageError";

export interface Point {
  x: number;
  y: number;
}

export interface Area {
  height: number;
  width: number;
  x: number;
  y: number;
}

export interface ImageCropperProps {
  aspectRatio?: number;
  crop: Point;
  file?: string;
  imageError?: string;
  onCropComplete: (croppedArea: Area, croppedAreaPixels: Area) => void;
  setCrop: (crop: Point) => void;
  setZoom: (zoom: number) => void;
  zoom: number;
}

export const ImageCropper = ({
  imageError,
  file,
  crop,
  aspectRatio,
  zoom,
  setCrop,
  setZoom,
  onCropComplete,
}: ImageCropperProps) => (
  <div className={anchorClassNames("crop-content")}>
    <ImageError error={imageError} />
    <div className={legacyClassNames("crop-content__box")}>
      <Cropper
        image={file}
        crop={crop}
        aspect={aspectRatio}
        zoom={zoom}
        onCropChange={setCrop}
        onZoomChange={setZoom}
        onCropComplete={onCropComplete}
      />
    </div>
    <CropSlider
      value={zoom}
      onChange={zoom => {
        if (Array.isArray(zoom) && typeof zoom[0] === "number") {
          setZoom(zoom[0]);
          return;
        }

        if (typeof zoom === "number") {
          setZoom(zoom);
        }
      }}
    />
  </div>
);
